import { useEffect } from "react";

const BrowserRedirect = () => {
  function isInstagramBrowser() {
    return /Instagram/.test(navigator.userAgent);
  }

  useEffect(() => {
    if (isInstagramBrowser()) {
      const url = window.location.href;

      // Detect iOS (iPhone/iPad)
      if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
        // Try opening in Safari
        window.location.href = `safari-https://${window.location.hostname}${window.location.pathname}`;

        // Fallback if Safari doesn't open
        setTimeout(() => {
          window.location.href = `https://apps.apple.com/us/app/safari/id1146562112`;
        }, 2000);
      }
      // Detect Android
      else if (/Android/.test(navigator.userAgent)) {
        // Try opening directly in Chrome first
        window.location.href = `googlechrome://${window.location.hostname}${window.location.pathname}`;

        // If Chrome doesn't open, try alternative methods
        setTimeout(() => {
          // Try using intent scheme
          window.location.href = `intent://${window.location.hostname}${window.location.pathname}#Intent;scheme=https;package=com.android.chrome;end`;

          // Try Samsung Internet as another fallback
          setTimeout(() => {
            window.location.href = `samsunginternet://open?url=${encodeURIComponent(
              url
            )}`;

            // Final fallback to Play Store
            setTimeout(() => {
              window.location.href = "market://details?id=com.android.chrome";
            }, 1000);
          }, 1000);
        }, 1000);
      } else {
        // For other browsers/devices
        alert(
          "Please open this page in your default browser for Google login to work."
        );

        // Try to copy URL to clipboard
        try {
          navigator.clipboard.writeText(url).then(() => {
            alert(
              "Website URL has been copied to your clipboard. Please paste it in your preferred browser."
            );
          });
        } catch (err) {
          console.error("Failed to copy URL:", err);
        }
      }
    }
  }, []);

  // Optional: You might want to show a loading message while redirect attempts are happening
  return null;
};

export default BrowserRedirect;
